import { IFilter } from "@/models/tables";
import { FilterTypes, FilterOperators } from "@/data/table";
import i18n from "@/i18n";
import { PurchaseTypes } from "@/data/enums/products";

const productsFilters: (args?: any) => IFilter[] = () => [
  {
    key: "name",
    label: i18n.t("_.product_name"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  },
  {
    key: "category_id",
    label: i18n.t("_.product_category"),
    type: FilterTypes.SELECT_MULTI,
    operator: FilterOperators.EQUAL,
    value: []
  },
  {
    key: "available_for_sales",
    label: i18n.t("_.active"),
    type: FilterTypes.SELECT_RADIO,
    operator: FilterOperators.EQUAL,
    value: "1"
  },
  {
    key: "clients_can_order",
    label: i18n.t("_.visible_for_clients"),
    type: FilterTypes.SELECT_RADIO,
    operator: FilterOperators.EQUAL,
    value: "1"
  },
  {
    key: "billing_cycle_months",
    label: i18n.t("_.purchase_type"),
    type: FilterTypes.SELECT_CHECKBOX,
    operator: FilterOperators.EQUAL,
    options: [
      {
        value: PurchaseTypes.ONE_OFF,
        label: i18n.t("_.one_off_payment")
      },
      {
        value: PurchaseTypes.RECURRING,
        label: i18n.t("_.recurring_payment")
      }
    ]
  },
  {
    key: "created_at",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

export { productsFilters };
